import { updateStore } from "./fx.js";
import { slice } from "./slice/index.js";
const defaultSchema = () => ({ cache: slice.table(), loaders: slice.loaders() });
export function createSchema(slices = defaultSchema()) {
    const db = Object.keys(slices).reduce((acc, key) => {
        // deno-lint-ignore no-explicit-any
        acc[key] = slices[key](key);
        return acc;
    }, {});
    const initialState = Object.keys(db).reduce((acc, key) => {
        // deno-lint-ignore no-explicit-any
        acc[key] = db[key].initialState;
        return acc;
    }, {});
    function* update(ups) {
        return yield* updateStore(ups);
    }
    db.update = update;
    return [db, initialState];
}
